import ProjectContainer from './container';

export default ProjectContainer;